export const REQUIRED_ERROR = 'This field is required'

export const INVALID_EMAIL_ERROR = 'Please enter a valid email'
export const INVALID_EMAIL_DOMAIN_ERROR =
  'The entered email does not belong to an allowed email domain'

export const INVALID_DROPDOWN_OPTION_ERROR =
  'Entered value is not a valid dropdown option'

export const CANNOT_TRANSFER_OWNERSHIP_TO_SELF =
  'You cannot transfer ownership to yourself'
export const INVALID_COUNTRY_REGION_OPTION_ERROR =
  'Please select a valid country/region from the dropdown list'
